import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HasRoleDirective } from './has-role.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [HasRoleDirective],
  exports: [HasRoleDirective],
})
export class HasRoleModule {}
